import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { SuggestionModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

/* Poolcorp Custom Code */
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { dispatchSuggestEvent } from "@store/Services/AnalyticsService";
import { getBloomreachSettings, getCurrentLanguage } from "@store/Store/Context/ContextSelectors";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";
/* Poolcorp Custom Code */

const mapStateToProps = (state: ApplicationState) => {
    const productsDataView = getProductListDataView(state);
    /* Poolcorp Custom Code */
    const bloomreachSettings = getBloomreachSettings(state);
    const currentLanguage = getCurrentLanguage(state);
    /* Poolcorp Custom Code */
    if (productsDataView.value) {
        return {
            loaded: true,
            searchPath: getSettingsCollection(state).searchSettings.searchPath,
            didYouMeanSuggestions: productsDataView.didYouMeanSuggestions,
            correctedQuery: productsDataView.correctedQuery,
            originalQuery: productsDataView.originalQuery,
            /* Poolcorp Custom Code */
            currentLanguage,
            bloomreachSettings,
            /* Poolcorp Custom Code */
        };
    }
    return {
        loaded: false,
        searchPath: "",
        didYouMeanSuggestions: [] as SuggestionModel[],
        correctedQuery: "",
        originalQuery: "",
        /* Poolcorp Custom Code */
        currentLanguage,
        bloomreachSettings,
        /* Poolcorp Custom Code */
    };
};

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> & HasHistory; // Poolcorp Custom Code

export interface ProductListSuggestionStyles {
    wrapper?: InjectableCss;
}

export const suggestionStyles: ProductListSuggestionStyles = {
    wrapper: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            text-align: left;
        `,
    },
};

const styles = suggestionStyles;

const ProductListSuggestion = ({
    loaded,
    searchPath,
    didYouMeanSuggestions,
    originalQuery,
    correctedQuery,
    /* Poolcorp Custom Code */
    bloomreachSettings,
    currentLanguage,
    history,
    /* Poolcorp Custom Code */
}: Props) => {
    if (!loaded) {
        return null;
    }

    /* Poolcorp Custom Code */
    const getDomainKey = () => {
        return bloomreachSettings?.domainKey;
    };
    const goToUrl = (event: React.MouseEvent, url: string) => {
        event.preventDefault();
        if (
            originalQuery &&
            didYouMeanSuggestions &&
            didYouMeanSuggestions.length > 0 &&
            currentLanguage &&
            bloomreachSettings
        ) {
            const suggestedTerm = didYouMeanSuggestions[0].suggestion;
            dispatchSuggestEvent(originalQuery, suggestedTerm, [{ name: getDomainKey() }]);
        }
        history.push(url);
    };
    /* Poolcorp Custom Code */

    return (
        <StyledWrapper {...styles.wrapper}>
            {didYouMeanSuggestions && didYouMeanSuggestions.length > 0 && (
                <>
                    {/* Poolcorp Custom Code */}
                    <Typography>{`${translate("Did you mean")} `}</Typography>
                    {/* Poolcorp Custom Code */}
                    <Link
                        href={`/${searchPath}?query=${didYouMeanSuggestions[0].suggestion}`}
                        /* Poolcorp Custom Code */
                        onClick={(event: React.MouseEvent) => {
                            goToUrl(event, `/${searchPath}?query=${didYouMeanSuggestions[0].suggestion}`);
                        }}
                        /* Poolcorp Custom Code */
                    >
                        {didYouMeanSuggestions[0].suggestion}
                    </Link>
                </>
            )}
            {correctedQuery && originalQuery !== correctedQuery && (
                <>
                    {/* Poolcorp Custom Code */}
                    <Typography>{`${translate("Search instead for")} `}</Typography>
                    {/* Poolcorp Custom Code */}
                    <Link
                        href={`/${searchPath}?query=${originalQuery}&includeSuggestions=false`}
                        data-test-selector="productListOriginalQuery"
                    >
                        {originalQuery}
                    </Link>
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(ProductListSuggestion)), // Poolcorp Custom Code
    definition: {
        // Poolcorp Custom Code
        group: "Product List",
        displayName: "Suggestion",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
